export const permissionsData = {
    'canEdit': 'canEdit'
}
